import {cleanNumberFormatter, dateFormatter, numberFormatter, percentageBarFormatter} from "../../gridFormatters";

export const databaseInstancesDefs = [
    {
        field: "database_server",
        headerName: "Server Name",
    },
    {
        field: "database_server_ip",
        headerName: "Server IP Address",
    },
    {
        field: "database_name",
        headerName: "Database Name",
    },
    {
        field: "database_type",
        headerName: "Database Type",
    },
    {
        field: "device_type_description",
        headerName: "Device Type",
        hide: true,
    },
    {
        field: "collection_date",
        headerName: "Last Collection Date",
        cellRenderer: dateFormatter,
    },
    {
        field: "edition",
        headerName: "Database Edition",
        hide: true,
    },
    {
        field: "family",
        headerName: "Database Family",
        hide: true,
    },
    {
        field: "version_full",
        headerName: "Version",
    },
    {
        field: "increment",
        headerName: "Increment",
        hide: true,
    },
    {
        field: "instance_name",
        headerName: "Instance Name",
    },
    {
        field: "status",
        headerName: "Status",
    },
    {
        field: "total_blocks",
        headerName: "Total Blocks",
        cellRenderer: cleanNumberFormatter,
        type: "numericColumn",
        aggFunc: "sum",
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
    },
    {
        field: "tables_count",
        headerName: "Tables Count",
        cellRenderer: cleanNumberFormatter,
        type: "numericColumn",
        aggFunc: "sum",
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
    },
    {
        field: "total_tablespaces_gb",
        headerName: "Total Table Space(GB)",
        cellRenderer: numberFormatter,
        type: "numericColumn",
        aggFunc: "sum",
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
    },
    {
        field: "total_used_gb",
        headerName: "Total Used Space(GB)",
        cellRenderer: numberFormatter,
        type: "numericColumn",
        aggFunc: "sum",
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
    },
    {
        field: "total_free_gb",
        headerName: "Total Free Space(GB)",
        cellRenderer: numberFormatter,
        type: "numericColumn",
        aggFunc: "sum",
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
    },
    {
        field: "pct_used",
        headerName: "Used Pct",
        cellRenderer: percentageBarFormatter,
        aggFunc: "avg",
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
    },
    {
        field: "total_users",
        headerName: "Total Users",
        cellRenderer: cleanNumberFormatter,
        type: "numericColumn",
        aggFunc: "sum",
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
    },
    {
        field: "user_blocks",
        headerName: "User Blocks",
        cellRenderer: cleanNumberFormatter,
        type: "numericColumn",
        aggFunc: "sum",
        hide: true,
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
    },
    {
        field: "user_bytes",
        headerName: "User Bytes",
        cellRenderer: cleanNumberFormatter,
        type: "numericColumn",
        aggFunc: "sum",
        hide: true,
        filter: "agNumberColumnFilter",
        filterParams: {
            cellHeight: 20,
            debounceMs: 1000
        },
    },
]
